import React from 'react';
import { browserHistory } from 'react-router';
import HostDetail from '../HostDetail';
import HostInfo from '../../model/HostInfo';
import * as actions from '../../redux/actions';

class HostDetailPage extends React.Component {
  componentWillMount() {
    let { params, dispatch } = this.props;
    let id = params.id;
    if (id) {
      dispatch(actions.getHostInfo(id)).then((data) => {
        // console.log('done loading ', data);
      });
    }
  }

  goBack() {
    let { params, dispatch } = this.props;
    let hostInfoId = params.id;
    dispatch(actions.updateLastAccessedKiosk(hostInfoId));
    browserHistory.goBack();
  }

  render() {
    let { hostInfoList, params } = this.props;
    let filteredList = hostInfoList.filter((hostInfo) => {
      return hostInfo.id === params.id;
    });
    let hostInfo = filteredList[0] || new HostInfo();

    return (
      <HostDetail hostInfo={hostInfo}
                  goBack={this.goBack.bind(this)}
                  {...this.props}/>
    );
  }
}

export default HostDetailPage;



// WEBPACK FOOTER //
// ./src/components/pages/HostDetailPage.js